export default __webpack_public_path__ + "static/cap1-4bae1201841103052c9046b34850aa83.mp4";